import { IMemberClient } from "@wingspanhq/payments/dist/interfaces";

export const selectorClientEmail = (memberClient: IMemberClient) =>
  memberClient.client.user.email;
